const LEARN_HEX_TECH_ORIGIN = "https://learn.hex.tech";

export function getStaticAssetOriginFromPath(
  staticAssetPath: string | undefined,
): string | null {
  if (staticAssetPath == null) {
    return null;
  }
  try {
    return new URL(staticAssetPath).origin;
  } catch {
    return null;
  }
}

export function shouldAllowDatadogRumTracingUrl(
  origin: string,
  {
    isScreenshotPage,
    staticAssetOrigin,
  }: {
    isScreenshotPage: boolean;
    staticAssetOrigin: string | null;
  },
): boolean {
  if (requestOriginMatches(origin, LEARN_HEX_TECH_ORIGIN)) {
    return false;
  }
  if (
    staticAssetOrigin != null &&
    isScreenshotPage &&
    requestOriginMatches(origin, staticAssetOrigin)
  ) {
    return false;
  }
  return origin.match(/https:\/\/.*\.hex\.tech/) != null;
}

function requestOriginMatches(
  requestOrigin: string,
  staticAssetOrigin: string,
): boolean {
  try {
    return new URL(requestOrigin).origin === staticAssetOrigin;
  } catch {
    return false;
  }
}

/** @internal Exported for unit tests. */
export const datadogRumTracingInternals = {
  requestOriginMatches,
};
